import { Link } from "react-router-dom";
import { AlertTriangle, MailX, CheckCircle2 } from "lucide-react";

const STATES = {
  expired: { icon: MailX, title: "This invitation has expired", body: "Invitations are valid for 72 hours. Ask the person who invited you to send a new one.", action: null },
  used: { icon: CheckCircle2, title: "This invitation was already accepted", body: "Your account is ready. Sign in with the email the invitation was sent to.", action: { to: "/login", label: "Sign in" } },
  invalid: { icon: AlertTriangle, title: "We couldn't verify this invitation", body: "The link may be incomplete or was copied incorrectly. Open the link from your email again, or ask for a new invitation.", action: { to: "/login", label: "Go to sign in" } },
  error: { icon: AlertTriangle, title: "Unable to verify invitation", body: "We couldn't reach SteelForgeAI. Check your connection and try again.", action: { retry: true, label: "Try again" } },
};

// Shared full-page state for invitation / reset-link problems. Never renders blank.
export function InviteStatePanel({ status, onRetry, testId = "invite-state" }) {
  const s = STATES[status] || STATES.invalid;
  const Icon = s.icon;
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6" data-testid={`${testId}-${status}`}>
      <div className="sc-card p-8 w-full max-w-md space-y-4">
        <Icon className="w-8 h-8 text-amber-400" />
        <h1 className="font-heading text-2xl font-extrabold text-slate-100">{s.title}</h1>
        <p className="text-sm text-slate-400">{s.body}</p>
        {s.action?.retry && <button onClick={onRetry} className="w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2 rounded" data-testid={`${testId}-retry`}>{s.action.label}</button>}
        {s.action?.to && <Link to={s.action.to} className="block text-center w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold py-2 rounded" data-testid={`${testId}-action`}>{s.action.label}</Link>}
        <div className="text-xs text-slate-500">Need help? <Link to="/login" className="text-amber-400 underline">Sign in</Link> or contact the admin who invited you.</div>
      </div>
    </div>
  );
}
